import {combine, merge, sample} from 'effector';

import {RestError, showRestError} from 'core/errors';
import {mapFilters} from 'utils/filters';

import {
    data$,
    fetchDataFx,
    Gate,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    filters$,
    filtersChanged,
    sorting$,
    sortingChanged,
    // totalCount$,
    fetchTotalCountFx,
} from './index';

data$.on(fetchDataFx.done, (state, {result}) => result).reset(Gate.close);
pageNumber$.reset(filtersChanged, sortingChanged, Gate.close);
pageSize$.reset(Gate.close);
filters$.reset(Gate.close);
sorting$.reset(Gate.close);

sample({
    clock: merge([Gate.open, pageNumberChanged, pageSizeChanged, sortingChanged, filtersChanged]),
    source: combine({
        state: Gate.state,
        pageNumber: pageNumber$,
        pageSize: pageSize$,
        filters: filters$,
        sorting: sorting$,
    }),
    fn: ({state, pageNumber, pageSize, filters, sorting}) => ({
        reportId: state.reportId,
        paging: {
            pageNumber,
            pageSize,
        },
        filters: mapFilters(filters),
        sortings: sorting,
    }),
    target: fetchDataFx,
});

fetchDataFx.fail.watch(({error}) => showRestError(error as RestError));
fetchTotalCountFx.fail.watch(({error}) => showRestError(error as RestError));
